import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { FaAlignJustify, FaAlignCenter } from "react-icons/fa";
import Kkmlogo from "../../asset/images/kkm-logo.png";
import { LanguageContext } from "../../context/LanguageContext";

import "./navbar.css";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const { language } = useContext(LanguageContext);

  return (
    <nav className={`navbar ${language}`}>
      <Link to="/" className="logo text-center">
        <img src={Kkmlogo} alt="KKM Logo" className="logo-img" />
        <h4>
          <b
            className={language === "ta" ? "site-title ta-title" : "site-title"}
          >
            {language === "ta" ? (
              <>
                கோவை கொங்குநாடு <br /> மேட்ரிமோனி
              </>
            ) : (
              <>
                Kovai Kongunadu <br /> Matrimony
              </>
            )}
          </b>
        </h4>
      </Link>

      <ul
        className={isMobile ? "nav-mobile-links" : "nav-links"}
        onClick={() => setIsMobile(false)}
      >
        <Link to="/" className="home small-screen-border">
          <li>HOME</li>
        </Link>
        <Link to="/about-us" className="aboutus">
          <li>ABOUT US</li>
        </Link>
        <Link to="/premiumplans" className="premiumplans">
          <li>PLAN DETAILS</li>
        </Link>
        <Link to="/success-stories" className="successstories">
          <li>SUCCESS STORIES</li>
        </Link>
        <Link to="/contact" className="contact">
          <li>CONTACT US</li>
        </Link>
      </ul>

      <button className="mob-menu-icon" onClick={() => setIsMobile(!isMobile)}>
        {isMobile ? <FaAlignJustify size={24} /> : <FaAlignCenter size={24} />}
      </button>
    </nav>
  );
};

export default Navbar;
